import { Skeleton, Stack } from '@mui/material';
import { ClarityEvents } from '../../../../lib/clarity/types/clarityEvents.types';
import { withEvent } from '../../../../lib/clarity/utils/captureEvent.utils';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import Tabs from '../../../v2/ui/Tabs/Tabs';
import { TableTab } from './tableTabs.types';

interface TableTabsProps<T extends TableTab> {
  tabs: T[];
  onClick: (tab: T) => void;
  selected: string;
  isLoading?: boolean;
}

const TableTabs = <T extends TableTab>({
  tabs,
  onClick,
  selected,
  isLoading,
}: TableTabsProps<T>) => {
  const { translate } = useTranslation();

  if (isLoading) {
    return (
      <Stack direction="row" sx={{ gap: 0.5 }}>
        {tabs.map((tab) => (
          <Skeleton
            key={tab.name}
            variant="rounded"
            width={translate(tab.title).length * 8 + String(tab.subTitle ?? '').length * 6 + 32}
            height={28}
            sx={{ borderRadius: 999 }}
          />
        ))}
      </Stack>
    );
  }

  const items = tabs.map((tab) => ({
    id: String(tab.name),
    label: tab.title,
    secondaryLabel: tab.subTitle,
    testId: tab.testId,
  }));

  const handleSelect = (id: string) => {
    const tab = tabs.find((t) => String(t.name) === id);

    if (!tab) {
      return;
    }

    withEvent(`${ClarityEvents.ALTER_LIST_TAB_WITH_NAME} ${translate(tab.title)}`, () =>
      onClick(tab),
    )();
  };

  return <Tabs items={items} selectedId={selected} onSelect={handleSelect} />;
};

export default TableTabs;
